import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  subLabel?: string;
  className?: string;
}
export function CTAButton({
  children,
  href = '#offer',
  subLabel,
  className = ''
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!href.startsWith('#')) return;
    e.preventDefault();
    document.getElementById(href.slice(1))?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className={`w-full ${className}`} data-id="element-66" data-mp="2tx046vqp36vp">
      <a href={href} onClick={handleClick} className="flex w-full items-center justify-center rounded-lg border-b-4 border-brand-charcoal/25 bg-brand-gold px-4 py-3.5 text-center text-sm font-extrabold uppercase leading-tight tracking-wide text-brand-charcoal shadow-lg transition-[transform,background-color,box-shadow] duration-200 ease-smooth hover:-translate-y-0.5 hover:bg-[#D6A94D] active:translate-y-0 sm:text-base focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-sage" data-id="element-67" data-mp="2oz8bw0m51iqz">
        {children}
      </a>
      {subLabel && <p className="mt-1.5 text-center text-[11px] font-bold uppercase tracking-wider text-brand-taupe" data-id="element-68" data-mp="1db9qdxsfng1d">
          {subLabel}
        </p>}
    </div>;
}